// Runtime helpers for the rasterised Australia mask. The mask itself is
// loaded as JSON in BootScene from `data/australia-mask.json` (produced by
// `build/04-rasterize-svg.mjs`).

import type { StateCode } from './types';

export const TILE_SIZE = 32;
// PixelLab isometric tiles render as a 32×32 PNG but the visible diamond
// inside is ~28 wide × 16 tall. Stride below 32 makes tiles overlap nicely
// and removes the checkerboard gap look you get with 32×32 spacing.
export const STRIDE_X = 24;
export const STRIDE_Y = 16;

export interface MaskJson {
  cols: number;
  rows: number;
  /** Each cell is a state code or null for ocean. */
  grid: (StateCode | null)[][];
}

export function tileKey(state: StateCode): string {
  return `tile-${state.toLowerCase()}`;
}

export function* landTiles(mask: MaskJson): Generator<{ col: number; row: number; state: StateCode }> {
  for (let row = 0; row < mask.rows; row++) {
    for (let col = 0; col < mask.cols; col++) {
      const state = mask.grid[row][col];
      if (state) yield { col, row, state };
    }
  }
}
